// 用来存当前行区域信息
export default{
    namespaced:true,
    state:{
        rowData:{},
    },
    mutations:{
        changeRowData(state,payload){
            state.rowData = payload;
        }
    }

}